import SessionData from "../entities/sessionData/SessionData";
import _ from "lodash";

export default class SessionDataFactory {

  static create(sessionData: any) {
    const cloneSessionData = _.cloneDeep(sessionData) as SessionData;
    if (!sessionData?.user) {
      cloneSessionData.user = {
        isLoggedIn: false,
        isAgent: false,
        firstName: '',
        lastName: '',
        userName: '',
        numberOfOrderItems: 0,
        email: '',
        telenorNalogId: '',
        wishlist: [],
        avatarUrl: null
      };
    }

    if (!sessionData.gtmData) {
      cloneSessionData.gtmData = {
        gtmAgentType: 'noData',
        gtmUserId: 'noData'
      };
    }

    cloneSessionData.gtmData.gtmAgentType = _.has(cloneSessionData, 'gtmData.gtmAgentType') ? cloneSessionData.gtmData.gtmAgentType : 'noData';
    cloneSessionData.gtmData.gtmUserId = _.has(cloneSessionData, 'gtmData.gtmUserId') ? cloneSessionData.gtmData.gtmUserId : 'noData';

    return new SessionData(
      cloneSessionData.user,
      cloneSessionData.flashMessages,
      cloneSessionData.captchaRequired,
      cloneSessionData.gtmData,
      cloneSessionData.numberOfOrderItems,
      cloneSessionData.redirectUser
    );
  }

}
